import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import ToolbarLinkOrButton from './ToolbarLinkOrButton';
const ToolbarIconButton = t0 => {
  const $ = _c(21);
  const {
    badgeColor: t1,
    className: t2,
    count,
    "data-xc": dataXc,
    icon: Icon,
    iconHeight: t3,
    iconWidth: t4,
    onClick,
    prefetch,
    to,
    title
  } = t0;
  const badgeColor = t1 === undefined ? "brand" : t1;
  const className = t2 === undefined ? "" : t2;
  const iconHeight = t3 === undefined ? 22 : t3;
  const iconWidth = t4 === undefined ? 24 : t4;
  const t5 = `items-center bg-transparent rounded-full border-2 border-solid border-transparent text-gray flex h-[38px] justify-center relative w-[38px] hover:text-brand focus:text-brand ${className}`;
  let t6;
  if ($[0] !== prefetch) {
    t6 = prefetch === false ? {
      prefetch: false
    } : {};
    $[0] = prefetch;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== title) {
    t7 = <VisuallyHidden>{title}</VisuallyHidden>;
    $[2] = title;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== Icon || $[5] !== iconHeight || $[6] !== iconWidth || $[7] !== title) {
    t8 = !!Icon && <Icon title={title} color="currentColor" width={iconWidth} height={iconHeight} />;
    $[4] = Icon;
    $[5] = iconHeight;
    $[6] = iconWidth;
    $[7] = title;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== badgeColor || $[10] !== count) {
    t9 = !!count && <div className={classNames("text-xs rounded-sm bottom-[5px] text-white inline-block font-bold h-[15px] absolute right-1 text-center w-[15px]", {
      "bg-brand": badgeColor === "brand",
      "bg-red": badgeColor === "red"
    })} aria-hidden={true} data-xc="CartCounter">{count}</div>;
    $[9] = badgeColor;
    $[10] = count;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== dataXc || $[13] !== onClick || $[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9 || $[19] !== to) {
    t10 = <ToolbarLinkOrButton className={t5} data-xc={dataXc} onClick={onClick} to={to} {...t6}>{t7}{t8}{t9}</ToolbarLinkOrButton>;
    $[12] = dataXc;
    $[13] = onClick;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = to;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};
ToolbarIconButton.propTypes = {
  badgeColor: PropTypes.oneOf(['brand', 'red']),
  className: PropTypes.string,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  'data-xc': PropTypes.string,
  icon: PropTypes.elementType,
  iconHeight: PropTypes.number,
  iconWidth: PropTypes.number,
  onClick: PropTypes.func,
  prefetch: PropTypes.bool,
  to: PropTypes.string,
  title: PropTypes.string
};
export default ToolbarIconButton;